<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Spinner
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height" *ngIf="isBrowser">
  <h2>Customized Spinner</h2>
  <div class="content__tools-wrap">
    <div class="content__row">
      <div class="c-input-check-inline">
        <label for="useCase" class="content__row-label">Use Cases</label>
        <select [(ngModel)]="selectedUseCase" class="c-input-group__control" id="useCase">
          <ng-container *ngFor="let useCase of useCases">
            <option [value]="useCase">{{ useCase }}</option>
          </ng-container>
        </select>
      </div>
      <div class="c-input-check-inline">
        <input id="hasBackgroundColor" class="c-input-check-inline__input" type="checkbox" name="hasBackgroundColor"
          [(ngModel)]="hasBackgroundColor">
        <label for="hasBackgroundColor" class="c-input-check-inline__label">Has Background Color</label>
      </div>
    </div>
  </div>
</div>
<div class="content" [ngClass]="{'content--theme-color': hasBackgroundColor}">
  <h2 *ngIf="selectedUseCase === 'Block'">Use Case 1 (Block)</h2>
  <maced-spinner *ngIf="selectedUseCase === 'Block'" spinnerId="Spinner4" size="block"></maced-spinner>
  <h2 *ngIf="selectedUseCase === 'Small'">Use Case 2 (Small)</h2>
  <maced-spinner *ngIf="selectedUseCase === 'Small'" spinnerId="Spinner2" size="small"></maced-spinner>
  <h2 *ngIf="selectedUseCase === 'Medium'">Use Case 3 (Medium)</h2>
  <maced-spinner *ngIf="selectedUseCase === 'Medium'" spinnerId="Spinner1"></maced-spinner>
  <h2 *ngIf="selectedUseCase === 'Large'">Use Case 4 (Large)</h2>
  <maced-spinner *ngIf="selectedUseCase === 'Large'" spinnerId="Spinner3" size="large"></maced-spinner>
</div>